import React from 'react';
import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { MenuItemWithAnalytics } from '@atlassian/learning-components';

import { subnavbarPrimaryItems, subnavbarSecondaryItems } from 'src/pages/utils/navigation';

import { withUrlPrefix } from './GlobalAppNavigation';

export const OnDemandMobileMenu: React.FC = () => (
  <>
    <ul css={[defaultListStyles, primaryListStyles]}>
      {subnavbarPrimaryItems.map(({ title, description, link }) => (
        <div key={title} css={primaryItemStyles}>
          <MenuItemWithAnalytics
            link={withUrlPrefix({ text: title, href: link })}
            type="subMenu"
            contentAfter={<span css={primaryItemDescriptionStyles}>{description}</span>}
          />
        </div>
      ))}
    </ul>
    <ul css={[defaultListStyles, secondaryListStyles]}>
      {subnavbarSecondaryItems.map(({ title, links }) => (
        <li key={title} css={secondaryItemStyles}>
          <span css={secondaryItemTitleStyles}>{title}</span>
          <ul css={defaultListStyles}>
            {links.map(({ text, href }) => (
              <div key={text} css={secondaryItemLinkContainerStyles}>
                <MenuItemWithAnalytics link={withUrlPrefix({ text, href })} type="subMenu" />
              </div>
            ))}
          </ul>
        </li>
      ))}
    </ul>
  </>
);

const defaultListStyles = css({
  listStyle: 'none',
  margin: 0,
  padding: 0,
});

const primaryItemStyles = css({
  display: 'flex',
  flexDirection: 'column',
  padding: `${token('space.200')} 0`,
  fontFamily: 'Charlie Text, sans-serif',

  '&:hover li': {
    color: token('color.link'),
  },

  li: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    fontWeight: 700,
    fontSize: '14px',
    lineHeight: '22px',
    color: '#101214',
    padding: 0,
    height: '42px',
  },
});

const primaryItemDescriptionStyles = css({
  fontWeight: 400,
  fontSize: '12px',
  lineHeight: '16px',
  color: '#505258 !important',
  zIndex: 1,
  cursor: 'pointer',
  marginTop: 0,
});

const primaryListStyles = css({
  marginBottom: token('space.300'),
});

const secondaryListStyles = css({
  padding: `0 ${token('space.300')} ${token('space.300')} ${token('space.300')} !important`,
  margin: `0 ${token('space.negative.300')} ${token('space.negative.300')} ${token('space.negative.300')} !important`,
  backgroundColor: '#F4F5F7',
});

const secondaryItemTitleStyles = css({
  display: 'inline-block',
  fontWeight: 700,
  fontSize: '12px',
  lineHeight: '16px',
  letterSpacing: 0,
  textTransform: 'uppercase',
  color: '#101214',
  marginBottom: `${token('space.100')} !important`,
  marginTop: '28px',
});

const secondaryItemStyles = css({
  borderBottom: `1px dashed ${token('color.border')}`,

  '&:last-of-type': {
    borderBottom: 'none',
  },
});

const secondaryItemLinkContainerStyles = css({
  padding: `${token('space.200')} 0`,

  li: {
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px',
    color: '#101214',
    textDecoration: 'none',
    fontFamily: 'Charlie Display, sans-serif',
    padding: 0,

    '&:hover': {
      color: token('color.link'),
    },
  },
});
